const NODES = [
    { id: "China", x: 354, y: 97, lx: 366, ly: 92 },
    { id: "Vietnam", x: 482, y: 195, lx: 494, ly: 192 },
    { id: "Thailand", x: 509, y: 318, lx: 470, ly: 346 },
    { id: "India", x: 97, y: 354, lx: 42, ly: 372 },
    { id: "Middle East", x: 103, y: 228, lx: 30, ly: 216 },
    { id: "Africa", x: 118, y: 405, lx: 56, ly: 428 },
    { id: "Europe", x: 211, y: 110, lx: 152, ly: 96 },
];

const HUB = { id: "Mauritius", x: 300, y: 510 };

const ARCS = [
    "M300,510 Q470,300 354,97",
    "M300,510 Q520,380 482,195",
    "M300,510 Q480,440 509,318",
    "M300,510 Q180,470 97,354",
    "M300,510 Q140,380 103,228",
    "M300,510 Q190,500 118,405",
    "M300,510 Q160,300 211,110",
    "M97,354 Q220,180 354,97",
    "M482,195 Q430,120 354,97",
];

export default function Globe({ className = "" }) {
    return (
        <svg
            viewBox="0 0 600 600"
            className={className}
            role="img"
            aria-label="Abstract globe showing connection lines between Mauritius, Asia, Africa, the Middle East and Europe"
        >
            <defs>
                <radialGradient id="vm-globe-shade" cx="38%" cy="32%" r="75%">
                    <stop offset="0%" stopColor="#101F38" stopOpacity="0.9" />
                    <stop offset="70%" stopColor="#081225" stopOpacity="0.35" />
                    <stop offset="100%" stopColor="#060D1A" stopOpacity="0.05" />
                </radialGradient>
            </defs>

            <circle cx="300" cy="300" r="210" fill="url(#vm-globe-shade)" stroke="rgba(197,160,89,0.35)" strokeWidth="1" />
            <circle cx="300" cy="300" r="238" fill="none" stroke="rgba(197,160,89,0.16)" strokeWidth="1" strokeDasharray="2 8" className="globe-ring-spin" />

            <ellipse cx="300" cy="300" rx="140" ry="210" fill="none" stroke="rgba(250,249,245,0.08)" strokeWidth="1" />
            <ellipse cx="300" cy="300" rx="70" ry="210" fill="none" stroke="rgba(250,249,245,0.08)" strokeWidth="1" />
            <line x1="90" y1="300" x2="510" y2="300" stroke="rgba(250,249,245,0.08)" strokeWidth="1" />
            <ellipse cx="300" cy="222" rx="176" ry="30" fill="none" stroke="rgba(250,249,245,0.07)" strokeWidth="1" />
            <ellipse cx="300" cy="378" rx="176" ry="30" fill="none" stroke="rgba(250,249,245,0.07)" strokeWidth="1" />
            <ellipse cx="300" cy="156" rx="118" ry="20" fill="none" stroke="rgba(250,249,245,0.05)" strokeWidth="1" />
            <ellipse cx="300" cy="444" rx="118" ry="20" fill="none" stroke="rgba(250,249,245,0.05)" strokeWidth="1" />

            {ARCS.map((d, i) => (
                <path
                    key={i}
                    d={d}
                    fill="none"
                    stroke="#C5A059"
                    strokeWidth="1.2"
                    strokeOpacity="0.55"
                    strokeLinecap="round"
                    className="arc-flow"
                    style={{ animationDelay: `${i * 0.35}s` }}
                />
            ))}

            {NODES.map((n, i) => (
                <g key={n.id}>
                    <circle cx={n.x} cy={n.y} r="6" fill="none" stroke="#C5A059" strokeWidth="1" className="node-pulse" style={{ animationDelay: `${i * 0.4}s` }} />
                    <circle cx={n.x} cy={n.y} r="3.2" fill="#E5C17C" />
                    <text x={n.lx} y={n.ly} fill="#94A3B8" fontSize="10" fontFamily="'Plus Jakarta Sans', sans-serif" letterSpacing="2" style={{ textTransform: "uppercase" }}>
                        {n.id.toUpperCase()}
                    </text>
                </g>
            ))}

            <g>
                <circle cx={HUB.x} cy={HUB.y} r="9" fill="none" stroke="#E5C17C" strokeWidth="1.2" className="node-pulse" />
                <circle cx={HUB.x} cy={HUB.y} r="4.5" fill="#C5A059" stroke="#060D1A" strokeWidth="1.5" />
                <text x={HUB.x - 40} y={HUB.y + 30} fill="#E5C17C" fontSize="11" fontWeight="600" fontFamily="'Plus Jakarta Sans', sans-serif" letterSpacing="2.5">
                    MAURITIUS
                </text>
            </g>
        </svg>
    );
}
